module.exports = __webpack_public_path__ + "static/img/cSP.1d52d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons_m/cSP.png
// module id = UQjO
// module chunks = 1 2